import React, { useEffect, useRef } from 'react';

interface IsolatedHtmlContentProps {
  html: string;
  className?: string;
  style?: React.CSSProperties;
}

export const IsolatedHtmlContent: React.FC<IsolatedHtmlContentProps> = ({
  html,
  className = '',
  style = {},
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isDarkMode = document.documentElement.classList.contains('dark');

  useEffect(() => {
    if (!iframeRef.current) return;

    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDoc) {
      // Set up the iframe document
      iframeDoc.open();
      iframeDoc.write(`
        <!DOCTYPE html>
        <html ${isDarkMode ? 'class="dark"' : ''}>
          <head>
            <style>
              body, html {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;
                background: transparent;
                color-scheme: ${isDarkMode ? 'dark' : 'light'};
              }
              body {
                padding: 16px;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                line-height: 1.5;
                color: ${isDarkMode ? '#e5e7eb' : '#1f2937'};
                background: transparent;
              }
              * {
                box-sizing: border-box;
              }
              a {
                color: ${isDarkMode ? '#60a5fa' : '#2563eb'};
                text-decoration: none;
              }
              a:hover {
                text-decoration: underline;
              }
            </style>
          </head>
          <body>
            <div id="content">${html}</div>
          </body>
        </html>
      `);
      iframeDoc.close();
    }
  }, [html, isDarkMode]);

  return (
    <iframe
      ref={iframeRef}
      className={`isolated-html-content ${className}`}
      style={{
        width: '100%',
        border: 'none',
        overflow: 'hidden',
        backgroundColor: 'transparent',
        ...style,
      }}
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      title="Isolated HTML Content"
    />
  );
};

export default IsolatedHtmlContent;
